/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Not_Found_MsgInputs */

const vi_customer_not_found_msg = /** @type {(inputs: Customer_Not_Found_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy khách hàng.`)
};

/**

* @param {Customer_Not_Found_MsgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_not_found_msg = /** @type {((inputs?: Customer_Not_Found_MsgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Not_Found_MsgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_not_found_msg(inputs)
});